__turbopack_context__.v({
  "contributors": "Contributors-module-scss-module__osAjaq__contributors",
  "contributors__list": "Contributors-module-scss-module__osAjaq__contributors__list",
  "contributors__title": "Contributors-module-scss-module__osAjaq__contributors__title",
});
